import { FC } from 'react';
import { Text, Box, ToggleSwitch } from '@bechtel/gds';
import { t, Trans } from '@lingui/macro';
import { BulkWeldAssignProps } from './types';
import { WeldAssignReassign } from '../index';

export const BulkWeldAssign: FC<BulkWeldAssignProps> = ({
  showItrCertDialog,
  selectedWeldIds,
  isFitupRequired,
  setIsFitupRequired,
  close,
}) => {
  return (
    <Box flexDirection={{ sm: 'column' }} style={{ height: '100%' }}>
      <Box justifyContent={{ sm: 'space-between' }} alignItems={{ sm: 'center' }} px={{ sm: '500' }} py={{ sm: '400' }}>
        <Box flexDirection={{ sm: 'column' }}>
          <Text size="500" family="graphik" color="bechtel.blue.700" weight="600">
            <Trans>Bulk Request</Trans>
          </Text>
          <Box mt={{ sm: '200' }}>
            <Text size="300" family="graphik" color="bechtel.blue.700">
              {`${selectedWeldIds.length} ${t`Weld(s) Selected`}`}
            </Text>
          </Box>
        </Box>
        <Box>
          <ToggleSwitch
            isToggled={isFitupRequired}
            onToggle={() => {
              setIsFitupRequired(!isFitupRequired);
            }}
          />
          <Box pl={{ sm: '450' }}>
            <Text size="300" color="grey.1000">
              <Trans>Fitup</Trans>
            </Text>
          </Box>
        </Box>
      </Box>
      <WeldAssignReassign
        isFitupRequired={isFitupRequired}
        weldIds={selectedWeldIds}
        close={close}
        showItrCertDialog={showItrCertDialog}
      />
    </Box>
  );
};
